module.exports = __webpack_public_path__ + "static/img/ARAD4N_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD4N_1.png
// module id = Zaod
// module chunks = 0